module.exports = "/_next/static/images/c51110378caf848f42885773ebfaf039-computer-desk-man@lg-1x.jpg";